import { defineComponent, ref } from 'vue'
import styles from './styles.module.scss'
import { cur, isIOS, isWB, isWX, ucur } from '@/utils/env'
import Tracker from '@nio-fe/nio-tracker-web'
import Mask, { MaskProps } from '@/components/mask'
import { useAppStore } from '../../stores/app'
import { handleUrlLink, openInApp, openLink } from '../../utils/openLink'

/**
 * 首页模块的底部按钮组
 */
export default defineComponent({
  name: 'btn-group-view',

  setup: () => {
    // 获取组件配置
    const componentsConfig: any = window.NSComponentsConfig
    const appStore = useAppStore()
    const maskRef = ref<MaskProps | null>()

    const testPower = ref<any>()
    const inviteDrive = ref<any>()

    const inviteTestDrive = (url: string) => {
      // 链接跳转埋点
      Tracker.track('nsh5m_driveclick', appStore.trackParamsCommon)
      if (isWB) {
        maskRef.value?.show()
      } else {
        handleUrlLink(url)
      }
    }

    const testPowerClick = (url: string) => {
      // 链接跳转埋点
      Tracker.track('nsh5m_retentionclick', appStore.trackParamsCommon)
      if (isWB) {
        maskRef.value?.show()
      } else {
        handleUrlLink(url)
      }
    }

    testPower.value = componentsConfig?.test_power
    inviteDrive.value = componentsConfig?.invite_drive

    return () => (
      <>
        {(inviteDrive.value?.show || testPower.value?.show) && (
          <div class={[styles.handleBtns]}>
            {inviteDrive.value?.show ? (
              <div
                class={[styles.btn, styles.round]}
                onClick={() =>
                  inviteTestDrive(
                    inviteDrive.value?.properties?.link ||
                      `https://app${ucur}.nio${
                        ucur === '-test' || ucur === '-dev' ? 'int' : ''
                      }.com/pe/h5/static/transit?wv=lg&type=powermap_poster`
                  )
                }
              >
                {inviteDrive.value?.properties.btn_text}
                {inviteDrive.value?.properties?.btn_corner_img ? (
                  <img src={inviteDrive.value?.properties?.btn_corner_img} />
                ) : null}
              </div>
            ) : null}
            {testPower.value?.show ? (
              <div
                class={[styles.btn, styles.prime, styles.round]}
                onClick={() =>
                  testPowerClick(
                    testPower.value?.properties?.link ||
                      `https://apollo${cur}.nio.com/driver?pageType=appDriver&load_js_bridge=true&show_navigator=false`
                  )
                }
              >
                {testPower.value?.properties.btn_text}
                {testPower.value?.properties?.btn_corner_img ? (
                  <img src={testPower.value?.properties?.btn_corner_img} />
                ) : null}
              </div>
            ) : null}
            <Mask ref={maskRef} />
          </div>
        )}
      </>
    )
  },
})
